export const BASE_URL = "https://torr-scraper.herokuapp.com/api/";
export const indexer = [
  {
    endpoint: "1337x",
    magnet_endpoint: "1337x_mg",
    website: "1337x",
  },

  {
    endpoint: "eztv",
    website: "eztv",
  },

  {
    endpoint: "horriblesubs",
    website: "Horriblesubs",
  },

  {
    endpoint: "nyaa",
    website: "Nyaa",
  },

  {
    endpoint: "kickass",
    website: "kickass",
    magnet_endpoint: "kickass_mg",
  },

  {
    endpoint: "limetorrents",
    website: "limetorrents",
    magnet_endpoint: "limetorrents",
  },

  {
    endpoint: "thepiratebay",
    website: "thepiratebay",
  },

  {
    endpoint: "skytorrents",
    website: "skytorrents",
  },

  {
    endpoint: "torrentdownloads",
    website: "torrentdownloads",
  },

  {
    endpoint: "tgx",
    website: "TorrentGalaxy",
  },

  {
    endpoint: "yts",
    website: "YTS",
  },
];
